// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breadcrumb":"LandingPageBreadcrumbs-9f42263b78fa0600"};